import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 8.787V7.333a5.334 5.334 0 0 0-10.666 0v1.454a2 2 0 0 0-1.334 1.88V12a2 2 0 0 0 2 2h2A.666.666 0 0 0 6 13.333v-4a.667.667 0 0 0-.667-.666H4V7.333a4 4 0 0 1 8 0v1.334h-1.333a.667.667 0 0 0-.667.666v4a.667.667 0 0 0 .667.667h2a2 2 0 0 0 2-2v-1.333a2 2 0 0 0-1.334-1.88M4.667 10v2.667H3.333A.667.667 0 0 1 2.667 12v-1.333A.667.667 0 0 1 3.333 10zm8.666 2a.667.667 0 0 1-.666.667h-1.334V10h1.334a.666.666 0 0 1 .666.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })